export default "__VITE_ASSET__bced81e4__"